<template>
	<template v-if="mobileBox && isMobile">
		<slot name="box" />
	</template>

	<el-table
		v-else
		:data="tableData"
		:empty-text="texts.table.emptyText"
		lazy
		v-loading="loading"
		:max-height="tableHeight"
		:default-sort="defaultSort"
		@row-click="(row, column, event) => $emit('rowClick', row, column, event)"
		@mousedown="handleClick"
		fit
		:ref="ref"
		:show-overflow-tooltip="true"
	>
		<slot />
	</el-table>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { texts } from '../utils/texts';
import { useStore } from '../store';

export default defineComponent({
	name: 'TheTable',
	data() {
		return {};
	},
	props: {
		tableData: {
			type: Array,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		showMaxRows: {
			type: Number,
			default: 4,
		},
		defaultSort: {
			type: Object,
		},
		ref: {
			type: String,
		},
		mobileBox: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['rowClick', 'rowClickNewTab'],
	computed: {
		texts() {
			return texts;
		},
		tableHeight() {
			const rowHeight = 72;
			const headerHeight = 40;
			const borderHeight = 5;
			return this.showMaxRows * rowHeight + headerHeight - borderHeight;
		},
	},
	methods: {
		handleClick(event: any) {
			if (event.button === 1) {
				const row = this.findRowFromEvent(event);
				if (row) {
					event.preventDefault();
					this.$emit('rowClickNewTab', row);
				}
			}
		},
		findRowFromEvent(event) {
			let element = event.target;
			while (element && element.tagName !== 'TR') {
				element = element.parentElement;
				if (!element || element.classList.contains('el-table')) {
					return null;
				}
			}

			const table = element.closest('.el-table');
			if (table) {
				const index = Array.from(table.querySelectorAll('tr')).indexOf(element);
				return this.tableData[index - 1];
			}
			return null;
		},
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			isMobile,
		};
	},
});
</script>
